import {
    EntityContext,
    EntityContextBase,
    EntityContextDto,
} from "./entity-context.dto";

export interface UserEntitiesResponse {
    entities: EntityContext[];
}

/**
 * Base type for UserEntitiesResponse - uses EntityContextBase.
 * Used by controllers and services.
 */
export interface UserEntitiesResponseBase {
    entities: EntityContextBase[];
}

export class UserEntitiesResponseDto {
    static deserialize(status: UserEntitiesResponseDto): UserEntitiesResponse {
        return {
            entities: status.entities.map(EntityContextDto.deserialize),
        };
    }

    entities: EntityContextDto[];

    constructor(status: UserEntitiesResponseBase) {
        this.entities = status.entities.map(
            (entityContext: EntityContextBase) =>
                new EntityContextDto(entityContext),
        );
    }
}
